module.exports = __webpack_public_path__ + "static/media/seer.99507372.svg";